import { render, staticRenderFns } from "./ComplianceLocationsWithNoElements.vue?vue&type=template&id=53afcde2&"
import script from "./ComplianceLocationsWithNoElements.vue?vue&type=script&lang=ts&"
export * from "./ComplianceLocationsWithNoElements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports